/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import Button from '../../fields/Button';
import { GLOBAL_VARIABLES } from '../../../../utilites/variables';
import allActions from '../../../../Store/action';
import { useDispatch, useSelector } from 'react-redux';
import { HandleFormData } from '../../../../utilites';

const OthersQuestions = () => {
	// ---------------------------------------
	// Variables , States & Store States
	// ---------------------------------------
	//
	const dispatch = useDispatch();

	const { otherQuestionsOptions } = GLOBAL_VARIABLES;
	const uploadFormData = HandleFormData({ parentIndex: 1, myIndex: 2 });
	const [{ taxPayerFormData, taxPayerForm, formInformation }] = useSelector((state) => [state.taxForms]);

	// For Choice Questions

	const [otherOptions, setOtherOptions] = useState([]);

	const [errors, setErrors] = useState({}); // Track errors for form fields

	// ---------------------------------------
	// HOOKS TO STORE DATA
	// ---------------------------------------
	useEffect(() => {
		setOtherOptions(JSON.parse(JSON.stringify(otherQuestionsOptions)));
	}, []);
	// SAVE VALUES TO STATES
	useEffect(() => {
		if (taxPayerForm?.data?.otherQuestionsForm) {
			if (Object.keys(taxPayerForm?.data?.otherQuestionsForm).length === 0) return;

			const { otherOptions } = taxPayerForm?.data?.otherQuestionsForm;
			setOtherOptions(otherOptions);
		}
	}, [taxPayerForm?.data?.otherQuestionsForm]);

	const handleQuestions = (index, bool) => {
		const localOtherOptions = otherOptions.slice();
		localOtherOptions[index].bool = bool;
		setOtherOptions(localOtherOptions);
	};

	// ---------------------------------------
	// Functions
	// ---------------------------------------
	const check_Validity = () => {
		setErrors({});
		const newErrors = {};

		// Add more validation rules as needed for other fields
		if (
			otherOptions
				?.flatMap((data) => {
					return data?.bool;
				})
				.includes(null)
		) {
			newErrors.AnswerOtherQuestions = 'Please Select Required Option';
		}

		setErrors(newErrors);

		let ConditionCheck = Object.keys(newErrors).length === 0 ? false : true;
		// Check if there are any errors
		return ConditionCheck;
	};

	const handleSubmit = (e) => {
		e.preventDefault();
		let errors = check_Validity();
		if (errors) return;

		let FormObj = { otherOptions };

		let formData = taxPayerForm;
		taxPayerForm.data.otherQuestionsForm = FormObj;
		dispatch(allActions.taxForms.StoreFormData({ formData }));

		uploadFormData(formData);
	};

	const goBack = () => {
		// CHANGE FORM TO BACK
		let parentIndex = 1;
		let myIndex = 2;
		dispatch(allActions.taxForms.moveToBack({ parentIndex, myIndex, taxPayerFormData }));
	};

	return (
		<form className="w-100 mt-3" onSubmit={handleSubmit}>
			<div className="mt-3 row justify-content-between px-3 custom-left-form">
				<p className="fw-bold">Other Questions</p>
				<div className=" mb-3 px-3">
					{otherOptions?.map((data, i) => {
						return (
							<div key={i} className="w-100  align-items-center justify-content-between mt-2">
								<small className="col-md-12 form-check-label text-start" htmlFor={`checkbox-${i}`}>
								{data.question}{data.bool===null&&<span className='text-danger small-text mx-1'>*Required</span>}
								</small>
								<div className="col-md-12">
									<input
										onChange={() => handleQuestions(i, true)}
										checked={data?.bool === true}
										className="form-check-input"
										type="radio"
										id={`checkbox-${i + 178}`}
										name={`checkbox-${i + 178}`}
									/>
									<label className="px-3 m-0 small" htmlFor={`checkbox-${i + 178}`} role="button">
										Yes
									</label>
									<input
										onChange={() => handleQuestions(i, false)}
										checked={data?.bool === false}
										className="form-check-input"
										type="radio"
										id={`checkbox-${i + 999}`}
										name={`checkbox-${i + 999}`}
									/>
									<label className="px-3 m-0 small" role="button" htmlFor={`checkbox-${i + 999}`}>
										No
									</label>
								</div>
							</div>
						);
					})}
				</div>
			</div>
			{Object.keys(errors)
				?.map((key) => {
					return errors[key];
				})
				?.map((data, index) => {
					return (
						<>
							<small className="text-primary" key={index}>
								{data}*
							</small>
							<br />
						</>
					);
				})}
			<div className="container-fluid content-row pb-4">
				<div className="d-flex align-items-center justify-content-center row">
					<Button
						mainClass="btn btn-info custon-button-text  w-100 text-dark"
						buttonText="Previous"
						wrapperClass={'w-25 custon-button  mt-4'}
						type="button"
						callback={() => goBack()}
					/>
					<Button
						mainClass="btn btn-primary custon-button-text   w-100"
						buttonText="Next"
						wrapperClass={'w-25 custon-button  mt-4'}
						type="submit"
						disabled={!formInformation?.lead_id}
					/>
				</div>
			</div>
		</form>
	);
};

export default OthersQuestions;
